import { BaseDto } from '@/shared/dtos/base-dto';

export class tipos_contrato extends BaseDto {
    public nombre !: string;
    public codigo !: string;
 } 
